/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Android_Google_Store_CancelInputs */

const en_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It appears you purchased Brave VPN on an Android device. You'll need to visit the Google Play Store to complete your cancellation.`)
};

const id_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampaknya Anda membeli Brave VPN di perangkat Android. Anda perlu mengunjungi Google Play Store untuk menyelesaikan pembatalan Anda.`)
};

const ms_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nampaknya anda membeli Brave VPN di peranti Android. Anda perlu melawat Google Play Store untuk melengkapkan pembatalan anda.`)
};

const ca_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembla que vas comprar Brave VPN en un dispositiu Android. Hauràs de visitar Google Play Store per completar la cancel·lació.`)
};

const cs_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdá se, že jste zakoupili Brave VPN na zařízení Android. K dokončení zrušení budete muset navštívit Google Play Store.`)
};

const da_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det ser ud til, at du har købt Brave VPN på en Android-enhed. Du skal besøge Google Play Store for at fuldføre din annullering.`)
};

const de_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es scheint, dass Sie Brave VPN auf einem Android-Gerät gekauft haben. Sie müssen den Google Play Store besuchen, um Ihre Kündigung abzuschließen.`)
};

const et_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tundub, et ostsite Brave VPN-i Android-seadmes. Tühistamise lõpetamiseks peate külastama Google Play Store'i.`)
};

const es_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parece que compraste Brave VPN en un dispositivo Android. Deberás visitar el Google Play Store para completar tu cancelación.`)
};

const fr_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il semble que vous ayez souscrit au VPN Brave depuis un appareil Android. Pour annuler, veuillez vous rendre sur le Google Play Store.`)
};

const hr_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čini se da ste kupili Brave VPN na Android uređaju. Trebat ćete posjetiti Google Play Store za dovršavanje otkazivanja.`)
};

const it_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembra che tu abbia acquistato Brave VPN su un dispositivo Android. Dovrai visitare il Google Play Store per completare la cancellazione.`)
};

const lv_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izskatās, ka iegādājāties Brave VPN uz Android ierīces. Lai pabeigtu atcelšanu, jums būs jādodas uz Google Play Store.`)
};

const lt_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panašu, kad Brave VPN pirkote Android įrenginyje. Norėdami užbaigti atšaukimą, apsilankykite Google Play Store.`)
};

const hu_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úgy tűnik, hogy Android-eszközön vásárolt Brave VPN-t. A lemondáshoz látogasson el a Google Play Áruházba.`)
};

const nl_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het lijkt erop dat je Brave VPN hebt gekocht op een Android-apparaat. Je moet naar de Google Play Store gaan om je annulering te voltooien.`)
};

const nb_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det ser ut til at du kjøpte Brave VPN på en Android-enhet. Du må åpne Google Play Store for å si opp abonnementet.`)
};

const pl_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygląda na to, że zakupiono Brave VPN na urządzeniu z Androidem. Aby anulować subskrypcję, musisz odwiedzić Sklep Google Play.`)
};

const pt_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parece que você comprou o Brave VPN em um dispositivo Android. Você precisará visitar a Google Play Store para completar seu cancelamento.`)
};

const ro_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se pare că ați achiziționat Brave VPN pe un dispozitiv Android. Trebuie să vizitați Google Play Store pentru a finaliza anularea.`)
};

const sk_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdá sa, že ste si zakúpili Brave VPN na zariadení Android. Na dokončenie zrušenia budete musieť navštíviť Google Play Store.`)
};

const sl_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videti je, da ste Brave VPN kupili na napravi Android. Za dokončanje preklica morate obiskati trgovino Google Play.`)
};

const fi_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näyttää siltä, että olet ostanut Brave VPN:n Android-laitteella. Sinun täytyy mennä Google Play Storeen peruaksesi.`)
};

const sv_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det verkar som om du köpte Brave VPN på en Android-enhet. Du måste besöka Google Play Store för att slutföra din avbokning.`)
};

const vi_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có vẻ như bạn đã mua Brave VPN trên thiết bị Android. Bạn sẽ cần truy cập Google Play Store để hoàn thành việc hủy bỏ của mình.`)
};

const tr_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görünüşe göre Brave VPN'i bir Android cihazında satın almışsınız. İptalinizi tamamlamak için Google Play Store'a gitmeniz gerekecek.`)
};

const el_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φαίνεται ότι αγοράσατε το Brave VPN σε μια συσκευή Android. Θα πρέπει να επισκεφθείτε το Google Play Store για να ολοκληρώσετε την ακύρωση.`)
};

const bg_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изглежда, че сте закупили Brave VPN на Android устройство. Ще трябва да посетите Google Play Store, за да завършите анулирането.`)
};

const ru_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Похоже, вы приобрели Brave VPN на устройстве с Android. Для завершения отмены вам нужно посетить Google Play Store.`)
};

const sr_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чини се да сте купили Brave VPN на Android уређају. Морате посетити Google Play Store да бисте завршили отказивање.`)
};

const uk_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви, здається, придбали Brave VPN на пристрої Android. Вам потрібно відвідати Google Play Store, щоб завершити скасування.`)
};

const ka_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`როგორც ჩანს, თქვენ შეიძინეთ Brave VPN Android მოწყობილობაზე. გთხოვთ ეწვიოთ Google Play Store-ს გაუქმებისთვის.`)
};

const hi_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऐसा लगता है कि आपने Android डिवाइस पर Brave VPN खरीदा है। रद्दीकरण को पूरा करने के लिए आपको Google Play Store पर जाना होगा।`)
};

const th_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูเหมือนว่าคุณซื้อ Brave VPN บนอุปกรณ์ Android คุณจะต้องไปที่ Google Play Store เพื่อทำการยกเลิกให้เสร็จสมบูรณ์`)
};

const ko_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android 기기에서 Brave VPN을 구매한 것으로 보입니다. 취소를 완료하려면 Google Play Store를 방문해야 합니다.`)
};

const zh_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您似乎是在 Android 设备上购买了 Brave VPN。您需要访问 Google Play Store 来完成取消操作。`)
};

const zh_tw_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您似乎是在 Android 裝置上購買了 Brave VPN。您需要前往 Google Play 商店完成取消程序。`)
};

const ja_android_google_store_cancel = /** @type {(inputs: Android_Google_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AndroidデバイスでBrave VPNを購入したようです。キャンセルを完了するにはGoogle Playストアにアクセスする必要があります。`)
};

/**
* | output |
* | --- |
* | "It appears you purchased Brave VPN on an Android device. You'll need to visit the Google Play Store to complete your cancellation." |
*
* @param {Android_Google_Store_CancelInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const android_google_store_cancel = /** @type {((inputs?: Android_Google_Store_CancelInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Android_Google_Store_CancelInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_android_google_store_cancel(inputs)
	if (locale === "ms") return ms_android_google_store_cancel(inputs)
	if (locale === "ca") return ca_android_google_store_cancel(inputs)
	if (locale === "cs") return cs_android_google_store_cancel(inputs)
	if (locale === "da") return da_android_google_store_cancel(inputs)
	if (locale === "de") return de_android_google_store_cancel(inputs)
	if (locale === "et") return et_android_google_store_cancel(inputs)
	if (locale === "es") return es_android_google_store_cancel(inputs)
	if (locale === "fr") return fr_android_google_store_cancel(inputs)
	if (locale === "hr") return hr_android_google_store_cancel(inputs)
	if (locale === "it") return it_android_google_store_cancel(inputs)
	if (locale === "lv") return lv_android_google_store_cancel(inputs)
	if (locale === "lt") return lt_android_google_store_cancel(inputs)
	if (locale === "hu") return hu_android_google_store_cancel(inputs)
	if (locale === "nl") return nl_android_google_store_cancel(inputs)
	if (locale === "nb") return nb_android_google_store_cancel(inputs)
	if (locale === "pl") return pl_android_google_store_cancel(inputs)
	if (locale === "pt") return pt_android_google_store_cancel(inputs)
	if (locale === "ro") return ro_android_google_store_cancel(inputs)
	if (locale === "sk") return sk_android_google_store_cancel(inputs)
	if (locale === "sl") return sl_android_google_store_cancel(inputs)
	if (locale === "fi") return fi_android_google_store_cancel(inputs)
	if (locale === "sv") return sv_android_google_store_cancel(inputs)
	if (locale === "vi") return vi_android_google_store_cancel(inputs)
	if (locale === "tr") return tr_android_google_store_cancel(inputs)
	if (locale === "el") return el_android_google_store_cancel(inputs)
	if (locale === "bg") return bg_android_google_store_cancel(inputs)
	if (locale === "ru") return ru_android_google_store_cancel(inputs)
	if (locale === "sr") return sr_android_google_store_cancel(inputs)
	if (locale === "uk") return uk_android_google_store_cancel(inputs)
	if (locale === "ka") return ka_android_google_store_cancel(inputs)
	if (locale === "hi") return hi_android_google_store_cancel(inputs)
	if (locale === "th") return th_android_google_store_cancel(inputs)
	if (locale === "ko") return ko_android_google_store_cancel(inputs)
	if (locale === "zh") return zh_android_google_store_cancel(inputs)
	if (locale === "zh-tw") return zh_tw_android_google_store_cancel(inputs)
	if (locale === "ja") return ja_android_google_store_cancel(inputs)
	return en_android_google_store_cancel(inputs)
});